import classNames from 'classnames';
import React from 'react';

import AccordionItem from '@jpp/atoms/AccordionItem';
import AnchorLink from '@jpp/atoms/AnchorLink';
import Heading from '@jpp/atoms/Heading';
import { EPageType } from 'common/typings/enums';

import './Accordion.scss';

interface IAccordionProps {
  className?: string;
  faqs: any[];
  pageType?: EPageType;
}

const ROOT_CLASSNAME = 'Accordion';

const Accordion: React.FunctionComponent<IAccordionProps> = ({
  className,
  faqs = [],
  pageType = EPageType.Page,
}) => {
  return (
    <div className={classNames(ROOT_CLASSNAME, className)}>
      {faqs.map(({ title: _title, content: _content, slug }) => {
        const title = _title?.rendered ?? _title;
        const content = _content?.rendered ?? _content;

        return (
          <React.Fragment key={slug}>
            <AnchorLink
              href={`/${pageType}/${slug}`}
              className={`${ROOT_CLASSNAME}__link`}
            >
              <Heading
                className={`${ROOT_CLASSNAME}__heading`}
                priority="2"
                children={pageType === EPageType.Faq ? `${title}?` : title}
              />
            </AnchorLink>
            <AccordionItem>{content}</AccordionItem>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Accordion;
